<template lang="pug">
	section#banner
		.wrapper
			h1 NA UNIFAEL VOCÊ TEM BOLSAS DE 100% E SÓ AQUI VOCÊ SE FORMA EM CURSOS SUPERIORES A PARTIR DE 18 MESES
			.video
				iframe(src="https://www.youtube.com/embed/xeuJsJwx8TU" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen)
			a(href="http://prouni.mec.gov.br/" target="_blank")
				span Inscreva-se
</template>

<script>
export default {
	name: "section-banner"
}
</script>

<style lang="stylus" scoped src="./Banner.styl"></style>
